export const GET_ADMINS = 'app/get_admins'
export const GET_ADMIN_BY_ID = 'app/get_admin_by_id'
export const DELETE_ADMIN_BY_ID = 'app/delete_admin'
export const CREATE_ADMIN = 'app/create_admin'
export const UPDATE_ADMIN = 'app/update_admin'
